import { RequestStatus } from "../../../request";

export interface RetentionState {
  report: RetentionReport | null;
  fetchRetentionReportRequestState: RequestStatus;
}

export const initialState: RetentionState = {
  report: null,
  fetchRetentionReportRequestState: {
    isLoading: false,
    isSuccessful: false,
    isFailed: false,
  },
};

export function Retention(state = initialState, action: any) {
  switch (action.type) {
    case "retention-update-request-state":
      return {
        ...state,
        fetchRetentionReportRequestState: action.requestState,
      };

    case "retention-update-report":
      return {
        ...state,
        report: action.report,
      };

    case "reset-data":
      return initialState;

    case "retention-reset-data":
      return initialState;

    default:
      return state;
  }
}

export interface RetentionRow {
  date: string;
  installs: number;
  spend: number;
  revenueD1: number;
  revenueD3: number;
  revenueD7: number;
  revenueD14: number;
  revenueD30: number;
  revenueD60: number;
  revenueD180: number;
  roasD0: number;
  roasD1: number;
  roasD3: number;
  roasD7: number;
  roasD14: number;
  roasD30: number;
  roasD60: number;
  roasD180: number;
}

export interface RetentionReport {
  from: Date;
  until: Date;
  rows: RetentionRow[];
}
